import React from "react";
import "./ResumeSectionStyle.css";
import { FaFileDownload, FaEye, FaFilePdf } from "react-icons/fa";

export default function ResumeSection() {
  return (
    <div className="resume-section-container">
      <div className="resume-card">
        <div className="resume-left">
          <FaFilePdf className="resume-icon" size={60} />
        </div>
        <div className="resume-middle">
          <h3>Resume / CV</h3>
          <p>View or download my professional resume</p>
        </div>
        <div className="resume-right">
          <a 
            href="/AhmedCv.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="resume-btn view-btn"
          >
            <FaEye size={18} />
            <span>View</span>
          </a>
          <a 
            href="/AhmedCv.pdf" 
            download="Ahmed_K_Alrasheed_Resume.pdf"
            className="resume-btn download-btn"
          >
            <FaFileDownload size={18} />
            <span>Download</span>
          </a>
        </div>
      </div>
    </div>
  );
}
